import React from 'react';
import PropTypes from 'prop-types';
import convertTcmLink from '../../utils/convertTcmLink';

const OrderedList = ({ list }) => (
  <ol>
    {list.map((listItem, listItemindex) => (
      <li key={listItemindex}>{convertTcmLink(listItem.text)}</li>
    ))}
  </ol>
);

OrderedList.propTypes = {
  list: PropTypes.array,
};

export default OrderedList;



// WEBPACK FOOTER //
// ./library/app/components/Content/OrderedList.js